import { Button } from "@/components/ui/button";
import { Inbox } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { HeaderParticleSystem } from "@/components/layout/HeaderParticleSystem";

export const SettingsHeader = () => {
  const navigate = useNavigate();

  return (
    <header className="bg-primary sticky top-0 z-50 h-[80px]">
      <div className="absolute inset-0 pointer-events-none">
        <HeaderParticleSystem />
      </div>
      <div className="relative max-w-[2000px] mx-auto w-full h-full flex items-center justify-between px-8 pointer-events-auto">
        <div className="flex items-center space-x-2">
          <img 
            src="/maia_logo_white.svg"
            alt="Maia Logo"
            className="h-8 w-auto"
          />
          {/* Hidden content for SEO */}
          <div className="sr-only">
            <h1>Maia Settings - Configure Your AI Email Assistant</h1>
            <h2>Customize Your Email Management Experience</h2>
            <h3>Comprehensive Settings for Email and AI Configuration</h3>
            <p>
              Configure your Maia experience with detailed settings for email accounts,
              AI assistants, and token management. Personalize your workflow for
              maximum efficiency.
            </p>
            <p>
              Access advanced features including email account management, AI assistant
              customization, token tracking, and account preferences all in one place.
            </p>
          </div>
        </div>
        <Button 
          variant="secondary" 
          onClick={() => navigate('/app')}
          className="relative z-10"
        >
          <Inbox className="h-4 w-4 mr-2" />
          Inbox
        </Button>
      </div>
    </header>
  );
};